export const INITIAL_VALUES = {
  name: '',
  phone: '',
  transport: '',
};
